
import { Component, Prop, Vue } from "vue-property-decorator";
import QaVue from "../qa/Qa.vue";
import { RouterHelper } from "@/router/routerHelper";
import { AxiosResponse } from "axios";
import { HttpHelper } from "@/helper/httpHelper";

@Component({
  components: {
    qa: QaVue,
  },
})
export default class LiteBeeWingFmQaVue extends Vue {
  prodName: string = "LiteBee Wing FM";
  prodCode: string = "liteBeeWingFm";

  tabList: Array<any> = [];

  linkData: Array<any> = [
    { name: "首页", link: "/" },
    { name: this.prodName, link: "/product/liteBeeWingFm" },
    { name: "常见问题", link: "#" },
  ];

  mounted() {
    RouterHelper.getProdRouterConfig(this.prodCode, (data: Array<any>) => {
      this.tabList = data;
    });
  }
}
